import Image from 'next/image';

import { Downloads } from '../../../interface/support-and-service';

/* eslint-disable-next-line */
type DownloadItemProps = {
  manualAndGuide: Downloads;
};

export function DownloadItem(props: DownloadItemProps) {
  const { manualAndGuide } = props;

  return (
    <div className="flex items-start space-x-2 w-full">
      <div className="relative flex-shrink-0 w-6 h-6">
        <Image
          alt="pdf icon"
          blurDataURL="/icons/blur-placeholder.png"
          layout="fill"
          objectFit="contain"
          placeholder="blur"
          src="/icons/pdf-icon.png"
        />
      </div>

      <a
        className="font-MuseoSans100 cursor-pointer hover:text-primaryBlue text-caption md:text-subtitle"
        href={`${manualAndGuide.File.data.attributes.url}`}
        rel="noreferrer"
        target="_blank"
      >
        {manualAndGuide.Name}
      </a>
    </div>
  );
}

export default DownloadItem;
